import React from 'react';
import { PollOption } from '../PollOption';

export function LiveVotingPollOption({ event, i18n }) {
    if (!event.settings.vote_url) return null;

    return (
        <PollOption
            href={event.settings.vote_url}
            icon={'img/vote_icon.png'}
            label={event.settings.vote_label || i18n['label.vote']}
        />
    );
}
